import { render } from "./TextCaseButtons.vue?vue&type=template&id=667dcd86"
import script from "./TextCaseButtons.vue?vue&type=script&lang=js"
export * from "./TextCaseButtons.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__